import { useState } from 'react'
import { Button } from '~/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/components/ui/dialog'

interface ReapproSimulationEmailDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  isPending: boolean
  onSubmit: (data: { emails: string[]; sendToPilotage: boolean }) => void
}

const parseEmails = (raw: string): string[] =>
  raw
    .split(/[,;\r\n]+/)
    .map((e) => e.trim().toLowerCase())
    .filter((e) => e.length > 0)

export const ReapproSimulationEmailDialog = ({
  open,
  onOpenChange,
  isPending,
  onSubmit,
}: ReapproSimulationEmailDialogProps) => {
  const [emailsRaw, setEmailsRaw] = useState('')
  const [sendToPilotage, setSendToPilotage] = useState(false)

  const handleOpenChange = (nextOpen: boolean) => {
    onOpenChange(nextOpen)
    if (!nextOpen) {
      setEmailsRaw('')
      setSendToPilotage(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Simulation Excel toutes boutiques</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Saisissez les emails destinataires, séparés par des virgules, points-virgules ou retours
            à la ligne.
          </p>
          <textarea
            className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            rows={3}
            placeholder="email1@exemple.com, email2@exemple.com"
            value={emailsRaw}
            onChange={(event) => setEmailsRaw(event.target.value)}
            disabled={isPending}
          />
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={sendToPilotage}
              onChange={(e) => setSendToPilotage(e.target.checked)}
              disabled={isPending}
              className="w-4 h-4 rounded accent-primary"
            />
            <span className="text-sm">Envoyer à tout le pilotage Lucie</span>
          </label>
        </div>
        <DialogFooter>
          <DialogClose render={<Button variant="outline" />}>Annuler</DialogClose>
          <Button
            onClick={() => onSubmit({ emails: parseEmails(emailsRaw), sendToPilotage })}
            disabled={isPending}
          >
            Envoyer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
